
import Order from '@/models/Order'
import CashRegister from '@/models/CashRegister';
import Store from '@/store';

const ORDER_NUMBER_KEY = 'last-order-number';
const ORDER_DATE_KEY = 'last-order-date';
const ORDER_INTERNAL_NUMBER_KEY = 'last-order-internal-number';

const OrderService = {

    /**
     * Set Latest Order Number
     */
    setLatestNumber(number, force = false) {
        const timezone = this.getTimezone()

        // check latest order
        const numberedOrders = Order.all()
            .filter(order => !!order.number && order.cash_register_id == CashRegister.current()?.id)
            .sort((o1, o2) => o2.number - o1.number)
        const lastOrder = numberedOrders.length > 0 ? numberedOrders[0] : null

        if(!force && lastOrder && parseInt(lastOrder.number) >= parseInt(number)) {
            number = parseInt(lastOrder.number) + 1
        }

        const year = moment().tz(timezone).format('YYYY')
        AppStorage.local().setItem(ORDER_NUMBER_KEY, `${number}/${year}`);

        return number
    },

    /**
     * Get Next Order Number
     */
    getNextNumber() {
        const timezone = this.getTimezone()

        const currentDate = moment().tz(timezone)
        const curNumber = AppStorage.local().getItem(ORDER_NUMBER_KEY)
        let nextNumber = curNumber ? parseInt(curNumber.split('/')[0]) + 1 : 1

        // check latest order
        const numberedOrders = Order.all()
            .filter(order => {
                const orderYear = moment.utc(order.last_activity_at).tz(timezone).year()
                return !!order.number && orderYear == currentDate.year() && order.cash_register_id == CashRegister.current()?.id
            })
            .sort((o1, o2) => o2.number - o1.number)

        const lastOrder = numberedOrders.length > 0 ? numberedOrders[0] : null

        if(lastOrder && parseInt(lastOrder.number) >= parseInt(nextNumber)) {
            nextNumber = parseInt(lastOrder.number) + 1
        }

        // check if we entered the new year
        if(curNumber && currentDate.format('YYYY') > curNumber.split('/')[1]) {
            nextNumber = 1
        }

        return nextNumber
    },

    /**
     * Set Latest Internal Order Number
     */
    setLatestInternalNumber(number){
        const timezone = this.getTimezone()

        const internalNumber = number.split('/')[0];

        const year = moment().tz(timezone).format('YYYY')
        AppStorage.local().setItem(ORDER_INTERNAL_NUMBER_KEY, `${internalNumber}/${year}`);

        return number
    },

    /**
     * Get Next Internal Order Number
     */
    getNextInternalNumber() {
        const timezone = this.getTimezone()

        const currentDate = moment().tz(timezone)
        const curNumber = AppStorage.local().getItem(ORDER_INTERNAL_NUMBER_KEY)
        let nextNumber = curNumber ? parseInt(curNumber.split('/')[0]) + 1 : 1

        // check latest order
        const numberedOrders = Order.all()
            .filter(order => {
                const orderYear = moment.utc(order.last_activity_at).tz(timezone).year()
                return !!order.internal_number && !order.isProforma() && orderYear == currentDate.year()
            })
            .sort((o1, o2) => parseInt(o2.internal_number) - parseInt(o1.internal_number))

        const lastOrder = numberedOrders.length > 0 ? numberedOrders[0] : null

        if(lastOrder && parseInt(lastOrder.internal_number) >= parseInt(nextNumber)) {
            nextNumber = parseInt(lastOrder.internal_number) + 1
        }

        // check if we entered the new year
        if(curNumber && currentDate.format('YYYY') > curNumber.split('/')[1]) {
            nextNumber = 1
        }

        return nextNumber
    },

    /**
     * Get Latest Order Date
     */
    getLatestOrderDate() {
        return AppStorage.local().getItem(ORDER_DATE_KEY);
    },

    /**
     * Set Latest Order Date
     */
    setLatestOrderDate(date) {
        AppStorage.local().setItem(ORDER_DATE_KEY, date);
    },

    getTimezone() {
        const timezone = Store.getters?.tenant?.venue?.timezone
        if(timezone) {
            return timezone
        }

        switch (locale) {
            case 'me':
                return 'Europe/Podgorica';
            case 'sr':
                return 'Europe/Belgrade';
            case 'ba':
                return 'Europe/Sarajevo';
            default:
                return 'UTC';
        }
  }
};

export default OrderService;

export { OrderService };
